import { post } from '../core/http';

const BASE_PATH = '/cart';

// ============================================================================
// Types
// ============================================================================

export interface CartItemDto {
  productId: string;
  variantId?: string;
  quantity: number;
  attributes?: Record<string, any>;
}

export interface ValidatedCartItem {
  productId: string;
  variantId?: string;
  name: string;
  price: number;
  quantity: number;
  subtotal: number;
  image: string;
  attributes?: Record<string, any>;
  available: boolean;
  stock: number;
}

export interface ValidatedCartResponse {
  items: ValidatedCartItem[];
  subtotal: number;
  itemCount: number;
  shippingCost?: number;
  total?: number;
  isFreeShipping?: boolean;
  shippingMessage?: string;
}

export interface ValidateCartRequest {
  items: CartItemDto[];
  destination?: {
    state: string;
    postalCode: string;
  };
}

// ============================================================================
// API Client
// ============================================================================

export const cartApi = {
  /**
   * Validate cart items and get current prices from backend
   * Backend is the authoritative source for all prices
   */
  validate: (request: ValidateCartRequest): Promise<ValidatedCartResponse> => {
    return post<ValidatedCartResponse>(`${BASE_PATH}/validate`, request);
  },

};
